import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { addManager } from "../../actions/restaurants";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getRestaurants } from "../../actions/restaurants";
import { removeUserFromState } from "../../actions/users";

function AddStoreToUser({ restaurants, user, addManager, getRestaurants, removeUserFromState }) {
	const { register, handleSubmit } = useForm();

	useEffect(() => {
		if (user.mail) {
			if (restaurants.length === 0) {
				getRestaurants();
			}
		}
	}, [user, getRestaurants, restaurants]);

	const onSubmit = async (data) => {
		addManager({ ...data, ...user });
	};

	if (user.mail) {
		return (
			<form onSubmit={handleSubmit(onSubmit)}>
				<TextField
					style={{ width: "300px", margin: 20 }}
					select
					SelectProps={{
						native: true,
						IconComponent: () => <ArrowDropDownIcon />,
					}}
					name="path"
					inputRef={register({ required: true, minLength: 2 })}
				>
					<option value={"noPath"}>Desasignar / Ninguno</option>
					{restaurants.map((store) => (
						<option key={store.path} value={store.path}>
							{`${store.name}`}
						</option>
					))}
				</TextField>
				<ButtonWithStyle type="submit">Asignar</ButtonWithStyle>
				<ButtonWithStyle onClick={removeUserFromState}>Buscar otro usuario</ButtonWithStyle>
			</form>
		);
	}
	return <div></div>;
}

const mapStateToProps = ({ user = null, restaurants = null }) => {
	return { user, restaurants };
};
export default connect(mapStateToProps, { addManager, getRestaurants, removeUserFromState })(AddStoreToUser);
